import React from 'react';

import { Tabs, TabsContent, TabsList, TabsTrigger } from 'shadcn/components/ui/Tabs';

/**
 * Pack week tabs as a week filter UI (previous / current / next).
 *
 * @param {Object} props
 * @param {Array<{ key: 'previous' | 'current' | 'next', week: number, year: number }>} props.options
 * @param {'previous' | 'current' | 'next'} props.value
 * @param {(next: 'previous' | 'current' | 'next') => void} props.onValueChange
 * @param {string} [props.className]
 */
function PackWeekTabs({ className, onValueChange, options, value }) {
    return (
        <Tabs className={className} value={value} onValueChange={onValueChange}>
            <TabsList className="w-fit">
                {options.map((option) => (
                    <TabsTrigger key={option.key} value={option.key}>
                        Week {option.week}
                    </TabsTrigger>
                ))}
            </TabsList>
            {/* Radix Tabs expects content nodes per panel; list acts as week filter only. */}
            {options.map((option) => (
                <TabsContent key={option.key} value={option.key} className="hidden" aria-hidden tabIndex={-1} />
            ))}
        </Tabs>
    );
}

export { PackWeekTabs };
